import { useEffect, useState } from 'react';
import '../styles/InstallExtensionBanner.css';
import {
  isChromiumDesktopBrowser,
  isExtensionBannerDismissed,
  detectListakiExtension,
  dismissExtensionBanner,
  EXTENSION_STORE_URL,
} from '../services/ExtensionDetectionService';

function InstallExtensionBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isChromiumDesktopBrowser() || isExtensionBannerDismissed()) return;

    detectListakiExtension().then((installed) => {
      if (!installed) {
        setVisible(true);
        if (window.umami) window.umami.track('extension-banner-shown');
      }
    });
  }, []);

  if (!visible) return null;

  const handleInstallClick = () => {
    if (window.umami) window.umami.track('extension-banner-install-click');
  };

  const handleDismiss = () => {
    dismissExtensionBanner();
    setVisible(false);
    if (window.umami) window.umami.track('extension-banner-dismiss');
  };

  return (
    <div className="extension-banner" role="status" aria-live="polite">
      <span>
        🧩 Ajoutez vos cadeaux en un clic depuis n'importe quel site avec l'extension Listaki (Chrome et Edge).
      </span>
      <div className="extension-banner-actions">
        <a
          href={EXTENSION_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="linklike"
          onClick={handleInstallClick}
        >
          Installer l'extension
        </a>
        <button className="extension-banner-dismiss" onClick={handleDismiss} aria-label="Fermer">
          ✕
        </button>
      </div>
    </div>
  );
}

export default InstallExtensionBanner;
